export enum MixpanelEvent {
  SAFE_APP_LAUNCHED = 'Safe App Launched',
  SAFE_CREATED = 'Safe Created',
  SAFE_ACTIVATED = 'Safe Activated',
  WALLET_CONNECTED = 'Wallet Connected',
  POSITION_EXPANDED = 'Position Expanded',
  POSITIONS_VIEW_ALL_CLICKED = 'Positions View All Clicked',
  EMPTY_POSITIONS_EXPLORE_CLICKED = 'Empty Positions Explore Clicked',
  PORTFOLIO_REFRESH_CLICKED = 'Portfolio Refresh Clicked',
  STAKE_VIEWED = 'Stake Viewed',
  EARN_VIEWED = 'Earn Viewed',
  WC_CONNECTED = 'WC Connected',
  CSV_TX_EXPORT_CLICKED = 'Export CSV Clicked',
  CSV_TX_EXPORT_SUBMITTED = 'CSV Exported',
  NATIVE_SWAP_VIEWED = 'Native Swap Viewed',
  SAFE_LABS_TERMS_ACCEPTED = 'Safe Labs Terms Accepted',
  SIDEBAR_CLICKED = 'Sidebar Clicked',
  GUARDIAN_BANNER_VIEWED = 'Guardian Banner Viewed',
  GUARDIAN_FORM_VIEWED = 'Guardian Form Viewed',
  GUARDIAN_FORM_STARTED = 'Guardian Form Started',
  GUARDIAN_FORM_SUBMITTED = 'Guardian Form Submitted',
  SECURITY_REPORT_CLICKED = 'Security Report Clicked',
  GUARDIAN_BANNER_DISMISSED = 'Guardian Banner Dismissed',
  EXPLORE_POSSIBLE_CLICKED = 'Explore Possible Clicked',
  EURCV_BOOST_EXPLORE_CLICKED = 'EURCV Boost Explore Clicked',
  EURCV_BOOST_BANNER_CLICKED = 'EURCV Boost Banner Clicked',
  EURCV_BOOST_BANNER_DISMISSED = 'EURCV Boost Banner Dismissed',
  TRANSACTION_STARTED = 'Transaction Started',
  TRANSACTION_RECIPIENT_DECODED = 'Transaction Recipient Decoded',
  TRANSACTION_CONTRACT_DECODED = 'Transaction Contract Decoded',
  TRANSACTION_THREAT_ANALYZED = 'Transaction Threat Analyzed',
  TRANSACTION_SIMULATED = 'Transaction Simulated',
  TRANSACTION_EXECUTED = 'Transaction Executed',
  TRANSACTION_EXECUTED_VIA_PARENT = 'Transaction Executed Via Parent',
  TRANSACTION_EXECUTED_IN_PARENT = 'Transaction Executed In Parent',
  TRANSACTION_EXECUTED_VIA_ROLE = 'Transaction Executed Via Role',
  TRANSACTION_SUBMITTED = 'Transaction Submitted',
  TRUSTED_SAFE_ADDED = 'Trusted Safe Added',
  TRUSTED_SAFE_REMOVED = 'Trusted Safe Removed',
  HYPERNATIVE_LOGIN_CLICKED = 'Hypernative Login Clicked',
  HYPERNATIVE_CONNECTED = 'Hypernative Connected',
  FALSE_RESULT_REPORTED = 'False Result Reported',
  WORKSPACE_DASHBOARD_VIEWED = 'Workspace Dashboard Viewed',
  AUTH_LOGIN_SUCCEEDED = 'Auth Login Succeeded',
  AUTH_LOGIN_FAILED = 'Auth Login Failed',
  AUTH_LOGGED_OUT = 'Auth Logged Out',
  WORKSPACE_CREATED = 'Workspace Created',
  WORKSPACE_MEMBER_INVITE_SENT = 'Workspace Member Invite Sent',
  WORKSPACE_MEMBER_INVITE_ACCEPTED = 'Workspace Member Invite Accepted',
  WORKSPACE_MEMBER_ROLE_CHANGED = 'Workspace Member Role Changed',
  WORKSPACE_MEMBER_REMOVED = 'Workspace Member Removed',
  WORKSPACE_MEMBER_INVITE_DECLINED = 'Workspace Member Invite Declined',
  SAFE_SELECTED = 'Safe Selected',
  CHAIN_SWITCHED = 'Chain Switched',
  WORKSPACE_SAFE_LINK_STARTED = 'Workspace Safe Link Started',
  WORKSPACE_SAFE_LINKED = 'Workspace Safe Linked',
  WORKSPACE_SAFE_UNLINKED = 'Workspace Safe Unlinked',
  ACCOUNTS_WIDGET_CLICKED = 'Accounts Widget Clicked',
  PENDING_TX_WIDGET_CLICKED = 'Pending TX Widget Clicked',
  WALLET_SWITCHED = 'Wallet Switched',
  WALLET_DISCONNECTED = 'Wallet Disconnected',
  WORKSPACE_CREATE_STARTED = 'Workspace Create Started',
  WORKSPACE_SWITCHED = 'Workspace Switched',
  ADDRESS_BOOK_ENTRY_CREATED = 'Address Book Entry Created',
  WORKSPACE_TRANSACTION_INITIATED = 'Workspace Transaction Initiated',
  ONBOARDING_WIZARD = 'Onboarding Wizard',
}

export enum WorkspaceCreateEntryPoint {
  WELCOME = 'welcome',
  SIDEBAR = 'sidebar',
}

export enum MixpanelUserProperty {
  WALLET_LABEL = 'Wallet Label',
  WALLET_ADDRESS = 'Wallet Address',
  SAFE_ADDRESS = 'Safe Address',
  SAFE_VERSION = 'Safe Version',
  NUM_SIGNERS = 'Number of Signers',
  THRESHOLD = 'Threshold',
  NETWORKS = 'Networks',
  TOTAL_TX_COUNT = 'Total Transaction Count',
  LAST_TX_AT = 'Last Transaction at',
  IS_OWNER = 'Is Owner',
}

export enum MixpanelEventParams {
  APP_VERSION = 'App Version',
  BLOCKCHAIN_NETWORK = 'Blockchain Network',
  DEVICE_TYPE = 'Device Type',
  SAFE_ADDRESS = 'Safe Address',
  EOA_WALLET_LABEL = 'EOA Wallet Label',
  EOA_WALLET_ADDRESS = 'EOA Wallet Address',
  EOA_WALLET_NETWORK = 'EOA Wallet Network',
  ENTRY_POINT = 'Entry Point',
  NUMBER_OF_OWNERS = 'Number of Owners',
  THRESHOLD = 'Threshold',
  DEPLOYMENT_TYPE = 'Deployment Type',
  PAYMENT_METHOD = 'Payment Method',
  SAFE_APP_NAME = 'Safe App Name',
  SAFE_APP_TAGS = 'Safe App Tags',
  LAUNCH_LOCATION = 'Launch Location',
  PROTOCOL_NAME = 'Protocol Name',
  LOCATION = 'Location',
  AMOUNT_USD = 'Amount USD',
  TOTAL_VALUE_OF_PORTFOLIO = 'Total Value of Portfolio',
  APP_URL = 'App URL',
  DATE_RANGE = 'Date Range',
  SIDEBAR_ELEMENT = 'Sidebar Element',
  RESULT = 'Result',
  SOURCE = 'Source',
  TRANSACTION_TYPE = 'Transaction Type',
  SPACE_ID = 'Space ID',
  WORKSPACE_ID = 'Workspace ID',
  AUTH_METHOD = 'Auth Method',
  FAILURE_REASON = 'Failure Reason',
  CHAIN_ID = 'Chain ID',
  TX_ID = 'TX ID',
  SAFE_SELECTOR_DROPDOWN = 'Safe Selector Dropdown',
}

export enum AuthLoginMethod {
  SIWE = 'siwe',
  EMAIL_OTP = 'email_otp',
  EMAIL_GOOGLE = 'email_google',
}

export enum SafeAppLaunchLocation {
  PREVIEW_DRAWER = 'Preview Drawer',
  SAFE_APPS_LIST = 'Safe Apps List',
}

export const ADDRESS_PROPERTIES = new Set([
  MixpanelEventParams.SAFE_ADDRESS,
  MixpanelEventParams.EOA_WALLET_ADDRESS,
  MixpanelUserProperty.SAFE_ADDRESS,
])
